import { render, staticRenderFns } from "./liveCheckins.vue?vue&type=template&id=485218ed&scoped=true"
import script from "./liveCheckins.vue?vue&type=script&lang=js"
export * from "./liveCheckins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485218ed",
  null
  
)

export default component.exports